export default "__VITE_PUBLIC_ASSET__ece267ee__"